const errorValidationApollo = (response, number = 0) => {
  // Check if the response contains GraphQL errors and if the specified error number exists
  const graphQLErrors = response.graphQLErrors || [];
  const error = graphQLErrors[number];
console.log(error)
console.log(error.extensions)
  if (error && error.extensions && error.extensions.validation) {
    console.log(2222)
    const validation = error.extensions.validation;
    console.log(validation)

    // Use Object.entries and reduce to create the validNew object
    const validNew = Object.entries(validation).reduce((acc, [key, value]) => {
      acc[key] = value[0]; // Assign the first validation error message to the key
      return acc;
    }, {});

    console.log(validNew)
    return validNew;
  }

  return {}; // Return an empty object if no validation errors are found
};

export default errorValidationApollo;